document.addEventListener("DOMContentLoaded", function () {
    const thumbPagination = new Swiper(".prd-thumb-pagination", {
        draggable: true,
        slidesPerView: 4,
        spaceBetween: 4,
        direction: "vertical",
        navigation: {
            nextEl: ".swiper-navi--next",
            prevEl: ".swiper-navi--prev",
        },
        on: {
            init: function (e) {
                e.slides.forEach((target, index) => {
                    target.addEventListener("keydown", (event) => {
                        if (event.key === "Enter") {
                            prdThumb.slideTo(index);
                        }
                    });
                });
            },
        },
    });

    const prdThumb = new Swiper(".prd-thumb", {
        draggable: true,
        autoHeight: true,
        slidesPerView: 1,
        thumbs: {
            swiper: thumbPagination,
        },
        pagination: {
            el: ".swiper-pagination",
        },
        on: {
            init: function (e) {
                const zoomModal = document.querySelector(".thumb-zoom");

                zoomModal
                    .querySelector(".thumb-zoom__close")
                    .addEventListener("click", () => {
                        zoomModal.dataset.open = false;
                        document.body.classList.remove("overflow-hidden");
                    });

                e.slides.forEach((target) => {
                    target.querySelector("a").addEventListener("click", function (event) {
                        const image = this.dataset.image;
                        zoomModal.querySelector("img").src = image;
                        zoomModal.dataset.open = true;
                        document.body.classList.add("overflow-hidden");
                    });
                });
            },
        },
    });

    const optionButtons = document.querySelectorAll(".option-btn");
    optionButtons.forEach((button) => {
        button.addEventListener("click", function () {
            // 이형상품이 2개 이상인 경우에만 처리
            if (optionButtons.length > 1) {
                // 모든 버튼에서 active 클래스 제거
                optionButtons.forEach((btn) =>
                    btn.classList.remove("option-btn--active")
                );
                // 클릭된 버튼에만 active 클래스 추가
                this.classList.add("option-btn--active");

                // 선택된 variant의 이미지 URL
                const variantImage = `https:${this.dataset.variantImage}`;

                if (variantImage) {
                    // product.media에서 해당 이미지와 동일한 슬라이드 찾기
                    const slides = document.querySelectorAll(".prd-thumb .swiper-slide");
                    slides.forEach((slide, index) => {
                        const slideImage =
                            slide.querySelector("img")?.src ||
                            slide.querySelector("a")?.dataset.image;
                        if (slideImage === variantImage) {
                            // 해당 슬라이드로 이동
                            prdThumb.slideTo(index);
                            thumbPagination.slideTo(index);
                        }
                    });
                }
            }
        });
    });

    // 아코디언 활성화
    const accordion = new iopeAccordion(".pdp-infor .iope-accordion").init();
});


